import * as React from "react";

function LongLeftArrow(props) {
  return (
    <svg viewBox="0 0 330 330" width="1em" height="1em" {...props}>
      <path d="M315 150H51.213l49.393-49.394c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-75 75c-5.858 5.857-5.858 15.355 0 21.213l75 75A14.956 14.956 0 0090 255a14.95 14.95 0 0010.606-4.394c5.858-5.857 5.858-15.355 0-21.213L51.213 180H315c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
    </svg>
  );
}

const MemoLongLeftArrow = React.memo(LongLeftArrow);
export default MemoLongLeftArrow;
